export const LabsListingShort = [
    {
        span: 9,
        height: "194px",
        classes: "marginTop-40",
        columns: [
            {
                span: 3,
                height: "104px",
            },
            {
                span: 6,
                height: "186px",
                rows: [
                    {
                        span: 6,
                        height: "60px",
                    },
                    {
                        span: 6,
                        height: "43px",
                        classes: "marginTop-8",
                    },
                    {
                        span: 6,
                        height: "27px",
                        classes: "marginTop-4",
                    },
                    {
                        span: 6,
                        height: "36px",
                        classes: "marginTop-8",
                    },
                ],
            },
        ],
    },
    {
        span: 9,
        height: "194px",
        classes: "marginTop-8",
        columns: [
            {
                span: 3,
                height: "104px",
            },
            {
                span: 6,
                height: "186px",
                rows: [
                    {
                        span: 6,
                        height: "60px",
                    },
                    {
                        span: 6,
                        height: "43px",
                        classes: "marginTop-8",
                    },
                    {
                        span: 6,
                        height: "27px",
                        classes: "marginTop-4",
                    },
                    {
                        span: 6,
                        height: "36px",
                        classes: "marginTop-8",
                    },
                ],
            },
        ],
    },
    {
        span: 9,
        height: "194px",
        classes: "marginTop-8",
        columns: [
            {
                span: 3,
                height: "104px",
            },
            {
                span: 6,
                height: "186px",
                rows: [
                    {
                        span: 6,
                        height: "60px",
                    },
                    {
                        span: 6,
                        height: "43px",
                        classes: "marginTop-8",
                    },
                    {
                        span: 6,
                        height: "27px",
                        classes: "marginTop-4",
                    },
                    {
                        span: 6,
                        height: "36px",
                        classes: "marginTop-8",
                    },
                ],
            },
        ],
    },
]
